import Colors from '@/constants/Colors';
import styled from 'styled-components';
import { classicFonts } from '../gameFonts.styled';

export const StyledClassicGameActivityWrapper = styled.div`
  ${classicFonts}
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .classic-game-activity {
    flex: 1;
    border-radius: 5px;
    border: 1px solid ${Colors.border};
    overflow: hidden;
  }

  &.fullscreen {
    .classic-game-activity {
      border-radius: 0;
      border: none;
    }
  }
`;

export const StyledClassicModalFeedback = styled.div`
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  position: relative;
  color: black;

  .finished-text {
    padding: ${(props) => props.stage.width * 0.02}px;
    background: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 4px solid ${Colors.success};
    gap: 10px;

    .title {
      color: ${Colors.success};
      font-size: ${(props) => props.stage.width * 0.04}px;
      margin-top: 0.5ex;
    }

    p {
      text-align: center;
      margin: 0 0 0.07em 0;
      font-size: ${(props) => props.stage.width * 0.025}px;
      line-height: 1.1;
      .time {
        color: ${Colors.blue};
        font-size: ${(props) => props.stage.width * 0.025}px;
      }
    }
  }
`;
